export const SEARCH_RESULTS_PATH = '/sr-artworks';
export const MIN_CHARACTERS = 2;
export const MAX_CHARACTERS = 50;
